import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PostOccupancyMonitoring = () => {
  const navigate = useNavigate();
  
  const handleViewDetails = (title: string) => {
    navigate(`/agency-solutions?search=${encodeURIComponent(title)}`);
  };

  const knowledgeBases = [
    {
      title: "Employee Experience & Feedback Integration",
      description: "Comprehensive systems for collecting and integrating employee experience feedback in federal workplace environments",
      type: "Feedback System",
      lastUpdated: "2024-01-26"
    },
    {
      title: "Predictive Maintenance: Building Systems Monitoring",
      description: "Predictive maintenance frameworks for monitoring and maintaining federal building systems and infrastructure",
      type: "Monitoring System",
      lastUpdated: "2024-02-18"
    },
    {
      title: "Building System Monitoring: Performance Dashboard",
      description: "Real-time performance dashboards for monitoring federal building systems and operational efficiency",
      type: "Dashboard",
      lastUpdated: "2024-02-05"
    },
    {
      title: "Occupant Comfort & Building Performance Feedback",
      description: "Tools for collecting and analyzing occupant comfort data and building performance feedback in federal facilities",
      type: "Analytics Tool",
      lastUpdated: "2024-01-22"
    },
    {
      title: "Continuous Improvement Implementation Strategies",
      description: "Strategic frameworks for implementing continuous improvement processes in federal building operations",
      type: "Strategy Framework",
      lastUpdated: "2024-02-12"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Post-Occupancy Monitoring</h1>
          <p className="text-muted-foreground">
            Comprehensive monitoring and feedback systems for evaluating federal building performance, occupant satisfaction, and continuous improvement strategies.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm" onClick={() => handleViewDetails(kb.title)}>
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default PostOccupancyMonitoring;